import React from "react";
import { Provider as JotaiProvider } from "jotai";
import { ModalProgramarMovimientos } from "./componentes/modalProgramarMovimientos";
import { BotonesProgramarMovimientos } from "./componentes/BotonesProgramarMovimientos";
import { ListaMovimientos } from "./componentes/ListaMovimientos";

const ProgramarMovimientosPage = () => {
	return (
		<JotaiProvider>
			<BotonesProgramarMovimientos />
			<ListaMovimientos />
			<ModalProgramarMovimientos />
			{/* <ModalFirmarSolicitudAusencia />
			<ModalRecordVacacional /> */}
		</JotaiProvider>
	);
};

export default ProgramarMovimientosPage;
